if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        if (!this.elements.viewer || !this.elements.thumbnails) return;

        this.onSlideChangedDebounced = debounce(
          this.onSlideChanged.bind(this),
          250
        );

        this.elements.viewer.addEventListener(
          'slideChanged',
          this.onSlideChangedDebounced
        );

        this.elements.thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;

          const mediaToSwitch = button.closest('[data-target]');
          if (!mediaToSwitch?.dataset?.target) return;

          this.setActiveMedia(mediaToSwitch.dataset.target);
        });

        if (
          this.dataset.desktopLayout?.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const mediaId =
          event?.detail?.currentElement?.dataset?.mediaId;

        if (!mediaId) return;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        if (!mediaId || !this.elements.viewer) return;

        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (!activeMedia) return;

        const previousActive =
          this.elements.viewer.querySelector(
            '[data-media-id].is-active'
          );

        if (
          previousActive &&
          previousActive !== activeMedia
        ) {
          previousActive.classList.remove('is-active');
        }

        activeMedia.classList.add('is-active');

        this.preventStickyHeader();

        requestAnimationFrame(() => {
          if (
            !this.mql.matches ||
            this.elements.thumbnails
          ) {
            activeMedia.parentElement?.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          if (activeMediaRect.top <= -0.5) {
            const top =
              activeMediaRect.top + window.scrollY;

            window.scrollTo({
              top,
              behavior: 'smooth',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(activeThumbnail);

        const mediaPosition =
          activeThumbnail?.dataset?.mediaPosition;

        if (mediaPosition) {
          this.announceLiveRegion(
            activeMedia,
            mediaPosition
          );
        }
      }

      setActiveThumbnail(thumbnail) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        const currentButton =
          this.elements.thumbnails.querySelector(
            'button[aria-current="true"]'
          );

        currentButton?.removeAttribute(
          'aria-current'
        );

        const nextButton =
          thumbnail.querySelector('button');

        if (!nextButton) return;

        nextButton.setAttribute(
          'aria-current',
          'true'
        );

        if (
          typeof this.elements.thumbnails
            .isSlideVisible === 'function' &&
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }

        this.elements.thumbnails.slider?.scrollTo({
          left: thumbnail.offsetLeft,
          top: thumbnail.offsetTop,
        });
      }

      announceLiveRegion(
        activeItem,
        position
      ) {
        if (
          !this.elements.liveRegion ||
          !window.accessibilityStrings
            ?.imageAvailable
        ) {
          return;
        }

        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        const announce = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            'false'
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings
              .imageAvailable
              .replace('[index]', position);

          window.setTimeout(() => {
            this.elements.liveRegion?.setAttribute(
              'aria-hidden',
              'true'
            );
          }, 2000);
        };

        if (image.complete) {
          announce();
        } else {
          image.addEventListener(
            'load',
            announce,
            {
              once: true,
            }
          );
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();

        const deferredMedia =
          activeItem.querySelector(
            '.deferred-media'
          );

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            'sticky-header'
          );

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer?.slider) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems
          ?.forEach((slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          });
      }
    }
  );
}


/* =========================================================
   PNZ - NAVEGAÇÃO DA GALERIA
========================================================= */

document.addEventListener(
  'DOMContentLoaded',
  () => {
    document
      .querySelectorAll('media-gallery')
      .forEach((mediaGallery) => {

        if (
          mediaGallery.dataset
            .pnzNavigationReady === 'true'
        ) {
          return;
        }

        const sliderComponent =
          mediaGallery.querySelector(
            '[id^="GalleryViewer"]'
          );

        if (!sliderComponent) return;

        mediaGallery.dataset
          .pnzNavigationReady = 'true';


        const getSlides = () =>
          Array.from(
            sliderComponent.querySelectorAll(
              '.slider__slide'
            )
          );


        const getCurrentIndex = (
          slides
        ) => {

          const activeIndex =
            slides.findIndex(
              (slide) =>
                slide.classList.contains(
                  'is-active'
                )
            );

          if (activeIndex >= 0) {
            return activeIndex;
          }

          const counterCurrent =
            sliderComponent.querySelector(
              '.slider-counter--current'
            );

          const counterIndex =
            Number.parseInt(
              counterCurrent?.textContent ||
                '1',
              10
            ) - 1;

          return Number.isFinite(
            counterIndex
          )
            ? Math.max(
                0,
                Math.min(
                  counterIndex,
                  slides.length - 1
                )
              )
            : 0;
        };


        const navigateSlider = (
          direction
        ) => {

          const slides = getSlides();

          if (slides.length < 2) {
            return;
          }

          const currentIndex =
            getCurrentIndex(slides);

          const offset =
            direction === 'next'
              ? 1
              : -1;

          const newIndex =
            (
              currentIndex +
              offset +
              slides.length
            ) % slides.length;

          const targetSlide =
            slides[newIndex];

          const targetMediaId =
            targetSlide?.dataset?.mediaId;

          if (!targetMediaId) return;

          mediaGallery.setActiveMedia(
            targetMediaId
          );

          const counterCurrent =
            sliderComponent.querySelector(
              '.slider-counter--current'
            );

          if (counterCurrent) {
            counterCurrent.textContent =
              String(newIndex + 1);
          }
        };


        sliderComponent.addEventListener(
          'click',
          (event) => {

            const button =
              event.target.closest(
                '.slider-button--prev, .slider-button--next'
              );

            if (!button) return;

            event.preventDefault();

            navigateSlider(
              button.classList.contains(
                'slider-button--prev'
              )
                ? 'prev'
                : 'next'
            );
          }
        );


        let touchStartX = null;


        sliderComponent.addEventListener(
          'touchstart',
          (event) => {

            touchStartX =
              event.touches?.[0]
                ?.clientX ?? null;

          },
          {
            passive: true,
          }
        );


        sliderComponent.addEventListener(
          'touchend',
          (event) => {

            if (touchStartX === null) {
              return;
            }

            const touchEndX =
              event.changedTouches?.[0]
                ?.clientX;

            if (
              typeof touchEndX !==
              'number'
            ) {
              touchStartX = null;
              return;
            }

            const diff =
              touchStartX - touchEndX;

            touchStartX = null;

            if (
              Math.abs(diff) <= 50
            ) {
              return;
            }

            navigateSlider(
              diff > 0
                ? 'next'
                : 'prev'
            );
          },
          {
            passive: true,
          }
        );

      });
  }
);